<app-nav></app-nav>

<section class="results">

  <!-- ═══════════ HERO ═══════════ -->
  <header class="results__hero">
    <!-- DESPUÉS -->
<div class="results__heroCarousel"
     [sharedHero]="'tipo-' + idTipo">
  <ng-container *ngIf="heroImgs?.length; else heroFallback">
    <img
      *ngFor="let img of heroImgs; let i = index"
      class="results__heroImg"
      [class.active]="i === heroIndex"
      [src]="img" alt="Hero"
    />
  </ng-container>
  <ng-template #heroFallback>
    <div class="results__heroPlaceholder"></div>
  </ng-template>
</div>

    <div class="results__heroOverlay">
      <div class="results__heroContent">
        <a class="back-btn" [routerLink]="['/lugares', townSlug]">
          ← Volver a categorías
        </a>
        <div class="results__heroBadge">{{ townSlug | titlecase }} · Quindío</div>
        <h1 class="results__title">{{ titulo }}</h1>
        <p class="results__subtitle">
          {{ filtered.length }} lugar{{ filtered.length !== 1 ? 'es' : '' }} disponible{{ filtered.length !== 1 ? 's' : '' }}
        </p>
      </div>
    </div>
  </header>

  <!-- ═══════════ SEARCH BAR ═══════════ -->
  <div class="results__searchBar">
    <form class="searchPill" (ngSubmit)="onSearch()">
      <svg width="18" height="18" fill="none" viewBox="0 0 24 24" class="searchPill__icon">
        <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2"/>
        <path d="M20 20l-3-3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <input
        type="text" name="q" [(ngModel)]="query"
        placeholder="Busca dentro de {{ titulo }}..."
        autocomplete="off" [disabled]="loading"
      />
      <button type="submit" [disabled]="loading">Buscar</button>
    </form>
  </div>

  <!-- ═══════════ PANEL ═══════════ -->
  <div class="results__panel">

    <!-- ═══════════ MAIN ═══════════ -->
    <main class="results__main">

      <!-- Loading -->
      <app-skeleton *ngIf="loading" type="lugar" [count]="4" />

      <!-- Error -->
      <app-empty
        *ngIf="!loading && errorMsg"
        type="lugar"
        title="Sin lugares disponibles"
        [description]="errorMsg"
        actionLabel="Volver a categorías"
        [actionRoute]="'/lugares/' + townSlug">
      </app-empty>

      <!-- Grid de cards -->
      <div class="cards" 
     *ngIf="!loading && !errorMsg"
     staggerList
     [staggerDelay]="90"
     staggerFrom="bottom">
        <button
          class="card"
          type="button"
          *ngFor="let item of filtered"
          (click)="openItem(item)"
        >
          <div class="card__imgWrap">
            <img *ngIf="item.img" [src]="item.img" [alt]="item.titulo" />
            <div class="card__noImg" *ngIf="!item.img">
              <span>{{ item.titulo[0] }}</span>
            </div>
          </div>
          <div class="card__body">
            <h3 class="card__name">{{ item.titulo }}</h3>
            <span class="card__cta">Ver más →</span>
          </div>
        </button>
      </div>

    </main>

  </div>
</section>


<!-- CHATBOT FLOTANTE MÓVIL -->
<div class="chatFab__backdrop" *ngIf="chatOpen" (click)="closeChatMobile()"></div>

<div class="chatFab__panel" [class.chatFab__panel--open]="chatOpen">
  <div class="chatFab__panelHeader">
    <div class="chatFab__panelHeaderLeft">
      <div class="aiPanel__avatar">
        <svg width="16" height="16" fill="none" viewBox="0 0 24 24">
          <path d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z" fill="#fff" opacity="0.9"/>
        </svg>
      </div>
      <div>
        <div class="chatFab__panelName">Asistente TripGo</div>
        <div class="aiPanel__status">
          <span class="aiPanel__dot"></span>
          En línea · IA activa
        </div>
      </div>
    </div>
    <button
        class="chatFab"
        type="button"
        *ngIf="!chatOpen"
        (click)="toggleChatMobile()"
      >
      <span>✨</span>
    </button>
  </div>

  <div class="aiPanel__suggestions">
    <span class="aiPanel__sugLabel">Sugerencias rápidas</span>
    <div class="aiPanel__chips">
      <button class="aiPanel__chip" type="button"
        (click)="askAI('¿Qué lugares me recomiendas en ' + townSlug + '?')">
        📍 Lugares top
      </button>
      <button class="aiPanel__chip" type="button"
        (click)="askAI('Plan romántico en ' + townSlug)">
        💫 Plan romántico
      </button>
      <button class="aiPanel__chip" type="button"
        (click)="askAI('Plan aventura en ' + townSlug)">
        🏔️ Aventura
      </button>
      <button class="aiPanel__chip" type="button"
        (click)="askAI('¿Qué comer en ' + townSlug + '?')">
        🍽️ Gastronomía
      </button>
    </div>
  </div>

  <div class="aiPanel__chat" #chatBoxMobile>
    <div *ngFor="let msg of chatMessages"
      class="aiMsg"
      [class.aiMsg--user]="msg.role==='user'"
      [class.aiMsg--ai]="msg.role==='ai'">

      <div *ngIf="msg.role==='ai'" class="aiMsg__avatar">✨</div>
      <div class="aiMsg__bubble">{{ msg.text }}</div>
    </div>
  </div>

  <form class="aiPanel__inputWrap" (ngSubmit)="sendAIMessage()">
    <input type="text"
      [(ngModel)]="aiQuery"
      name="aiQueryMobile"
      placeholder="Pregunta lo que quieras..."
      [disabled]="aiLoading"
      autocomplete="off"/>

    <button type="submit" [disabled]="aiLoading || !aiQuery.trim()">➤</button>
  </form>
</div>

<app-footer></app-footer>
